import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The unreasonable difficulty of adding a feature to a Textarea",
  "description": "",
  "published": "2019-07-15T00:00:00.000Z",
  "redirect_from": ["/blog/the-unreasonable-difficulty-of-adding-a-feature-to-a-textarea/swizec/9155"],
  "categories": "Front End, Livecoding, Technical",
  "hero": "./img/techletter.app-screenshot-1563209614123.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Here's a fun challenge for ya: Add Giphy support to GitHub comments. How hard can it be?`}</p>
    <p>{`Indeed, how hard `}<em parentName="p">{`can`}</em>{` it be?`}</p>
    <p><img parentName="p" {...{
        "src": "/55cf61a3edc0a6e9df4c9bb6ace923b4/media-26vUNcTowp5UTuOZO-giphy.gif",
        "alt": "psht giphy"
      }}></img></p>
    <p>{`45min speedcoding challenge! `}<em parentName="p">{`That`}</em>{`'s how hard.`}</p>
    <p>{`All you need is a Chrome extension that injects a little input field next to each comment. Type search into input field, press Enter, talk to Giphy's API, add markdown to the textarea.`}</p>
    <p>{`Piece of cake.`}</p>
    <p>{`So on Monday I gave it a shot ...`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=JtgVsrW7WkI"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.05381165919282%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'225\\'%20viewBox=\\'0%200%20400%20225\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M63%204L12%205l-1%202c-1%202-1%202-6%202l-5%201v18h220v-6l1-6%201-4c0-3%200-3-4-3l-4-1c1-4-4-4-4-1-1%202-1%202-1%200V4H63m-41%207c-3%204-1%204%2063%204%2056%200%2062%200%2063-2l-1-2c-2-2-123-1-125%200m168%2095v12c1%202%2011%202%2016%201l4-1v-12l-10-1-10%201m153%2029v2c2%201%201%204-1%204h-5c-2%202%200%203%203%202s3-1%204%203v5c-1%202-1%208%201%2010v2c-1%200-2%205-1%208l25%201h26v-9h-48l24-1h24v-12l-16-1-16-1h32v-8l-8-1-8-1h8c7%200%208%200%208-2s-1-2-25-2l-27%201M0%20162l2%202v13l-2%2031v17h401v-17c0-12-1-14-1-9l-1%207-1%201c-1%203-2%202-3-2l-1-5v-2l1-6v-5h-51v5l1%206v2c-1%201-2%202-2%205l-1%204h-5c-2-1-2-1-3%202v4H223v-6l-1-28v-22H0v3m63%202l-6%201%203%201h1v2c1%200%202%201%202%204-1%204-1%204%2013%201l11-2-7%202c-12%203-15%204-11%204s3%201-2%203c-3%201-3%201-5-2-3-2-3-2-7-1l-7%202c-3%201-3%201-3%205v5c0%202%203%202%2012-1%203-1%205-2%206-1h3l21-6%2021-5%201-7v-6H89l-26%201m281%2011v10h51v-12h-25c-22%200-26%200-26%202M70%20190l-1%203c-2%200-5-1-5-3h-3l-1%205c1%203%200%202-3-3h-6l-4%201v3c0%204%200%204-2%204s-2%200-1%202h3c2-2%203-1%203%202%200%202%200%202%203%202%201-1%203%200%204%202l3%202%201%202c0%201%203%202%203%200v-2c0-1%201-2%203-2%201-1%201-1-2-1l-3-1%202-3%201-3c-1-1-1-1%201-1%201-1%203-1%204%201%202%202%202%202%202-5l-2-8v3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/786e48287251fdf7cc6d3a63f68cf7e2/ca0a1/techletter.app-screenshot-1563209614123.webp 223w", "/static/786e48287251fdf7cc6d3a63f68cf7e2/75680/techletter.app-screenshot-1563209614123.webp 445w", "/static/786e48287251fdf7cc6d3a63f68cf7e2/0ba47/techletter.app-screenshot-1563209614123.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/786e48287251fdf7cc6d3a63f68cf7e2/e92b6/techletter.app-screenshot-1563209614123.png 223w", "/static/786e48287251fdf7cc6d3a63f68cf7e2/e66bf/techletter.app-screenshot-1563209614123.png 445w", "/static/786e48287251fdf7cc6d3a63f68cf7e2/6af66/techletter.app-screenshot-1563209614123.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/786e48287251fdf7cc6d3a63f68cf7e2/6af66/techletter.app-screenshot-1563209614123.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`... and failed miserably.`}</p>
    <p><a parentName="p" {...{
        "href": "https://swizec.com/blog/build-chrome-extension/swizec/8278"
      }}>{`Chrome extensions are easy in theory`}</a>{`, but I wanted to use React for reasons. A different project where it makes more sense and this was a good excuse to figure it out.`}</p>
    <p>{`Well, it didn't work. It is nigh impossible to convince create-react-app to work as a Chrome Extension.`}</p>
    <p>{`Until I discovered `}<a parentName="p" {...{
        "href": "https://github.com/satendra02/react-chrome-extension"
      }}>{`react-chrome-extension`}</a>{`. A boilerplate that comes with everything configured. Build steps, manifest files, full React support. It's wonderful 👌`}</p>
    <h2 {...{
      "id": "attempt-no-2"
    }}>{`Attempt no. 2`}</h2>
    <p>{`React problem resolve, surely this is gonna be a piece of cake now. Let's do this!`}</p>
    <p>{`Friday I tried again`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=5XRyY6YQzjA"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.05381165919282%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'225\\'%20viewBox=\\'0%200%20400%20225\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M12%205l-1%202c1%201-1%202-6%202s-5%200-5%204v3h12l12-1-1-1v-3h133c2%200%202%201%202%203l-1%202h66v-3c0-3-1-4-4-4s-4-1-4-2c0-2-5-3-5%200-1%201-1%201-1-1V4h-98L12%205m178%20101v12c1%202%2013%203%2017%201%203-1%203-1%203-7v-6l-10-1-10%201m154%2029v11c-2%200-1%206%201%208s2%202%200%202c-3%201-3%208%200%209l-1%201-1%205c0%203%201%204%206%204l5%201h-5l-5%201v8h51v-9h-21l-20-1h41v-9h-48l24-1h24v-5l-1-4v-12l1-5v-5h-25l-26%201m-226%2017c0%209%200%209-2%209-3%200-3%200-3%206v7l-8%202-10%202a606%20606%200%2000-26%204l-1-3%202-3c3-1%204-4%203-5-2-1-3-5-2-5v-1c0-1-9-1-10%201l-2%201v-2c2-2%202-2-8-3a113%20113%200%2000-34%200c0-2-5-1-6%201-1%203-1%207%201%208v2c-2%201-2%204-2%209%200%207-2%2012-4%209-1-3-4-2-4%200l2%203c4%201%205%205%203%2012-1%204-1%205-2%204l-3-1c-2%200-2%201-2%208v8h401v-10c0-9-1-12-3-8-2%201-2%201-3-3v-17l-25-1-26%201v13l-1%205v4l-4-1c-4-1-4-1-5%203%200%203-1%203-4%203-2%200-3-1-3-2h-1l-1%202c-1%200-2-22-2-48l1-24H118v10m-60%2028l-7%204-3%203v2l-1%202-1%201h-2l2%201h2l12-3c2%200%203%200%203%202s1%201%203-2c2-2%202-2%204-1%201%201%201%201%201-1l-1-3-3-3c-1-5-4-5-9-2m33%201l-8%202%202%201%201%201%202%201%201-1%203%201c3%203%209%203%2011%200%201-2%201-2%204%200h4c2-3%201-4-4-4l-6-1H91m-23%2013c-1%201-2%202-3%201l-1%201-1%203c-2%201-2%201-1-2v-3l-4%201c-4%202-5%203-3%207h-1l-2-3c0-2-2-3-6-3l-3%201%203%202%205%205%203%202h2l-1%201-1%201h3c5%200%205-1%204-3-3-2-2-3%201-2%205%201%207%202%207%204l1%202%201-4-1-4-1-1%201-1c1%201%203-1%203-3h-1c-2%201-2%201-2-1s-1-2-2-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/97ffd016f4db2fd3e4c6d1b35a5c35a5/ca0a1/techletter.app-screenshot-1563209614108.webp 223w", "/static/97ffd016f4db2fd3e4c6d1b35a5c35a5/75680/techletter.app-screenshot-1563209614108.webp 445w", "/static/97ffd016f4db2fd3e4c6d1b35a5c35a5/0ba47/techletter.app-screenshot-1563209614108.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/97ffd016f4db2fd3e4c6d1b35a5c35a5/e92b6/techletter.app-screenshot-1563209614108.png 223w", "/static/97ffd016f4db2fd3e4c6d1b35a5c35a5/e66bf/techletter.app-screenshot-1563209614108.png 445w", "/static/97ffd016f4db2fd3e4c6d1b35a5c35a5/6af66/techletter.app-screenshot-1563209614108.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/97ffd016f4db2fd3e4c6d1b35a5c35a5/6af66/techletter.app-screenshot-1563209614108.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`We wasted time drinking beer and shooting the shit about San Francisco, Silicon Valley, and some recent career news on my end (more on that later). Would you say SF is fancy? It's covered in poop, but also seeing a Porsche is so common you don't even notice anymore 🤔`}</p>
    <p>{`But `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/giphs-for-github"
      }}>{`giphs-for-github`}</a>{` worked!`}</p>
    <p><img parentName="p" {...{
        "src": "/daa1953b3ada2176386158f99fc5c31f/KlXRBoP.gif",
        "alt": null
      }}></img></p>
    <p>{`Well ... the operation was a success but the patient died. Oops.`}</p>
    <h3 {...{
      "id": "the-giphy-part"
    }}>{`The Giphy part`}</h3>
    <p>{`Finding a giph was easy. Giphy's API is great and React Hooks make building small forms a breeze.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=import%20React%2C%20%7B%20useState%20%7D%20from%20%22react%22%3B%0Aimport%20giphyAPI%20from%20%22giphy-api%22%3B%0A%0Aconst%20Giphys%20%3D%20(%7B%20target%20%7D)%20%3D%3E%20%7B%0A%20%20%20%20const%20%5Bsearch%2C%20setSearch%5D%20%3D%20useState(%22%22)%3B%0A%0A%20%20%20%20async%20function%20findGiphy()%20%7B%0A%20%20%20%20%20%20%20%20const%20results%20%3D%20await%20giphyAPI(%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20apiKey%3A%20GIPHY_KEY%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20https%3A%20true%0A%20%20%20%20%20%20%20%20%7D).search(search)%3B%0A%0A%20%20%20%20%20%20%20%20const%20giph%20%3D%20results.data.filter(d%20%3D%3E%20d.type%20%3D%3D%3D%20%22gif%22)%5B0%5D%3B%0A%20%20%20%20%20%20%20%20%0A%20%20%20%20%20%20%20%20%2F%2F%20insert%20into%20target%0A%0A%20%20%20%20%20%20%20%20setSearch(%22%22)%3B%0A%20%20%20%20%7D%0A%0A%20%20%20%20function%20onSubmit(event)%20%7B%0A%20%20%20%20%20%20%20%20event.preventDefault()%3B%0A%20%20%20%20%20%20%20%20findGiphy()%3B%0A%20%20%20%20%7D%0A%0A%20%20%20%20return%20(%0A%20%20%20%20%20%20%20%20%3Cform%20onSubmit%3D%7BonSubmit%7D%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20Add%20a%20Giph%20%F0%9F%91%89%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cinput%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20value%3D%7Bsearch%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20onChange%3D%7Bevent%20%3D%3E%20setSearch(event.target.value)%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20%2F%3E%0A%20%20%20%20%20%20%20%20%3C%2Fform%3E%0A%20%20%20%20)%3B%0A%7D%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "638px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "122.42152466367713%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'490\\'%20viewBox=\\'0%200%20400%20490\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M21%2031l-1%20215v213l3%201h354l3-1V246l-1-215c-2-2-356-2-358%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/305d6402fd615e817a95e7759e6d8e4f/ca0a1/techletter.app-screenshot-1563209612510.webp 223w", "/static/305d6402fd615e817a95e7759e6d8e4f/75680/techletter.app-screenshot-1563209612510.webp 445w", "/static/305d6402fd615e817a95e7759e6d8e4f/a2d8a/techletter.app-screenshot-1563209612510.webp 638w"],
                "sizes": "(max-width: 638px) 100vw, 638px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/305d6402fd615e817a95e7759e6d8e4f/e92b6/techletter.app-screenshot-1563209612510.png 223w", "/static/305d6402fd615e817a95e7759e6d8e4f/e66bf/techletter.app-screenshot-1563209612510.png 445w", "/static/305d6402fd615e817a95e7759e6d8e4f/41be6/techletter.app-screenshot-1563209612510.png 638w"],
                "sizes": "(max-width: 638px) 100vw, 638px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/305d6402fd615e817a95e7759e6d8e4f/41be6/techletter.app-screenshot-1563209612510.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`A single `}<inlineCode parentName="p">{`<Giphys>`}</inlineCode>{` component.`}</p>
    <ol>
      <li parentName="ol">{`Render a form with an input element`}</li>
      <li parentName="ol">{`Use a `}<inlineCode parentName="li">{`search`}</inlineCode>{` state`}</li>
      <li parentName="ol">{`Run `}<inlineCode parentName="li">{`setSearch`}</inlineCode>{` on change events`}</li>
      <li parentName="ol">{`Call `}<inlineCode parentName="li">{`findGiphy`}</inlineCode>{` on submit and prevent default`}</li>
      <li parentName="ol">{`Use `}<a parentName="li" {...{
          "href": "https://github.com/austinkelleher/giphy-api"
        }}>{`giphy-api`}</a>{` to run a search query`}</li>
      <li parentName="ol">{`Take the first result`}</li>
      <li parentName="ol">{`Insert into textarea`}</li>
    </ol>
    <p>{`Rendering this next to every textarea is a matter of some classic DOM manipulation. Find all textareas, inject an element in their parent.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=import%20ReactDOM%20from%20%22react-dom%22%3B%0A%0Afor%20(const%20node%20of%20document.getElementsByTagName(%22textarea%22))%20%7B%0A%20%20%20%20const%20div%20%3D%20document.createElement(%22div%22)%3B%0A%20%20%20%20node.parentNode.insertBefore(div%2C%20node)%3B%0A%0A%20%20%20%20ReactDOM.render(%3CGiphys%20target%3D%7Bnode%7D%20%2F%3E%2C%20div)%3B%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "606px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "51.569506726457405%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'207\\'%20viewBox=\\'0%200%20400%20207\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M22%2033c-2%202-2%20140%200%20142s354%202%20356%200%202-140%200-142-354-2-356%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/58a3a037ef26207f03394b8c16562483/ca0a1/techletter.app-screenshot-1563209612788.webp 223w", "/static/58a3a037ef26207f03394b8c16562483/75680/techletter.app-screenshot-1563209612788.webp 445w", "/static/58a3a037ef26207f03394b8c16562483/18e7e/techletter.app-screenshot-1563209612788.webp 606w"],
                "sizes": "(max-width: 606px) 100vw, 606px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/58a3a037ef26207f03394b8c16562483/e92b6/techletter.app-screenshot-1563209612788.png 223w", "/static/58a3a037ef26207f03394b8c16562483/e66bf/techletter.app-screenshot-1563209612788.png 445w", "/static/58a3a037ef26207f03394b8c16562483/4d4a2/techletter.app-screenshot-1563209612788.png 606w"],
                "sizes": "(max-width: 606px) 100vw, 606px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/58a3a037ef26207f03394b8c16562483/4d4a2/techletter.app-screenshot-1563209612788.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Works great 👌`}</p>
    <p>{`So why does it break the textarea?`}</p>
    <h2 {...{
      "id": "attempt-no-3"
    }}>{`Attempt no. 3`}</h2>
    <p>{`The most obvious way to add content to a textarea using JavaScript looks like this.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=target.value%20%2B%3D%20%60!%5B%24%7Bgiph.slug%7D%5D(%24%7Bgiph.images.downsized_medium.url%7D)%60%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "670px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "27.802690582959645%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'112\\'%20viewBox=\\'0%200%20400%20112\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M20%2031c-2%203-1%2051%200%2052%202%202%20358%202%20360%200%201-1%202-49%200-52-1-3-359-3-360%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ccca411379d22c1662bdf9f601cbb2ad/ca0a1/techletter.app-screenshot-1563209612765.webp 223w", "/static/ccca411379d22c1662bdf9f601cbb2ad/75680/techletter.app-screenshot-1563209612765.webp 445w", "/static/ccca411379d22c1662bdf9f601cbb2ad/6cceb/techletter.app-screenshot-1563209612765.webp 670w"],
                "sizes": "(max-width: 670px) 100vw, 670px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ccca411379d22c1662bdf9f601cbb2ad/e92b6/techletter.app-screenshot-1563209612765.png 223w", "/static/ccca411379d22c1662bdf9f601cbb2ad/e66bf/techletter.app-screenshot-1563209612765.png 445w", "/static/ccca411379d22c1662bdf9f601cbb2ad/d67fd/techletter.app-screenshot-1563209612765.png 670w"],
                "sizes": "(max-width: 670px) 100vw, 670px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/ccca411379d22c1662bdf9f601cbb2ad/d67fd/techletter.app-screenshot-1563209612765.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><inlineCode parentName="p">{`target`}</inlineCode>{` is our textarea node. Its value resides in the `}<inlineCode parentName="p">{`.value`}</inlineCode>{` property and the DOM spec allows us to change it.`}</p>
    <p>{`Value is just a string so we `}<inlineCode parentName="p">{`+=`}</inlineCode>{` another string. Works.`}</p>
    <p>{`But GitHub's JavaScript framework freaks out. The Comment button doesn't become enabled, there's an error, and anything you type into the textarea triggers even more errors.`}</p>
    <p>{`Which brings us to Sunday when I tried to figure this out once and for all.`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=7vM1hJCVUKg"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.05381165919282%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'225\\'%20viewBox=\\'0%200%20400%20225\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M12%205v2c0%202-4%203-8%202H0v33c0%2031%200%2033%202%2033%201%200%202-3%202-30V16h10l10-1-1-1c-2%200-1-3%201-3h133l1%203c1%201%201%202%2033%202h32v-3c0-3-1-4-4-4s-4-1-4-2c0-3-5-2-5%200-1%202-1%202-1%200V4h-98L12%205m178%20102v11c1%202%2013%203%2017%201%203-1%203-1%203-7v-6l-10-1c-8%200-10%200-10%202m153%2030c0%202%201%203%202%203v2c-3%202-2%2018%200%2020v2c-2%201-2%202-2%206%200%209-2%208%2027%208h25v-7c0-5%200-7-2-8v-1c2%200%202-1%202-14v-14h-24c-20%200-23%200-22%201v2c-2%201-2%200-2-1%200-3-4-3-4%201m-227%205l1%201%201%2011v10h-5v13l2%2017%201%202-1%202-1%208-1%209-24-1-24-1h1l2-1-1-1c-2%200-2-9-1-12v-1l1-1c2-1%202-1%200-2-4-2-5-4-2-4l3-2%201-2v2c0%202%200%202%202%202l1%201%201-1v-4l-3-4c-3-16-18-21-28-10-4%203-6%2013-5%2021v5c-1%201%200%201%201%201%202%200%203%202%201%202l-2%201%203%201%202%201h-6c-8%200-11-2-5-2l-3-1c-5-1-6-1-3-2%202%200%203-1%203-5l-1-5-1-1h-3c-3%200-3%200-2-1%202-2%202-2%200-2-1%200-2%200-1-1%201%200-1-3-3-3v-1l1-3v-2l1%201h2l-1-2h-3l-1-1%203-1c1%201%202%200%203-1l2-2c2%200%207-6%207-7-1-2-7-2-9-1h-1c0-2-6-1-7%201v3l-1-3-1-2c-3%200-4%202-4%2013l-3%2022-1%203c0%207-2%2012-3%207-1-1-1%203-1%209v10h401v-11c0-6%200-10-1-9h-1l-1%201-1%202c-1%200-2-6-2-13v-5l-25-1-26%201v10l-1%205c0%203-1%204-4%204s-4%200-5%202l-1%204c-2%201-6-1-6-3%200-1-1-1-1%201-2%204-3-10-3-42l1-29H221a4580%204580%200%2001-105%200m-62%2034l-1%202-1%201c-1-1-1-1%200%200l-1%201v1l-1%201h-1l4%201%204%201h4l6-1c3%201%203%200-1-4-3-4-8-5-12-3m289%205v5c1%202%202%202%2027%202h25v-8l-26-1h-25l-1%202\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/070ee371f53aa5f1ce9c7b0478e20e69/ca0a1/techletter.app-screenshot-1563209613720.webp 223w", "/static/070ee371f53aa5f1ce9c7b0478e20e69/75680/techletter.app-screenshot-1563209613720.webp 445w", "/static/070ee371f53aa5f1ce9c7b0478e20e69/0ba47/techletter.app-screenshot-1563209613720.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/070ee371f53aa5f1ce9c7b0478e20e69/e92b6/techletter.app-screenshot-1563209613720.png 223w", "/static/070ee371f53aa5f1ce9c7b0478e20e69/e66bf/techletter.app-screenshot-1563209613720.png 445w", "/static/070ee371f53aa5f1ce9c7b0478e20e69/6af66/techletter.app-screenshot-1563209613720.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/070ee371f53aa5f1ce9c7b0478e20e69/6af66/techletter.app-screenshot-1563209613720.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`That was ... fun? Confusing? I learned more than I ever wanted to know about keyboard events? 🤨`}</p>
    <h3 {...{
      "id": "why-is-this-so-hard"
    }}>{`Why is this so hard?`}</h3>
    <p>{`The problem is two-fold:`}</p>
    <ol>
      <li parentName="ol">{`Pressing Enter causes an error. GitHub's code picks up on the event and gets confused`}</li>
      <li parentName="ol">{`GitHub's framework is data-driven. Our shenanigans put reality out of sync with internal state and GitHub JS gets confused`}</li>
    </ol>
    <p>{`I don't know what they use, but you can imagine why it wouldn't like outsiders messing with things.`}</p>
    <p>{`Nothing a little change event can't fix.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=target.value%20%2B%3D%20%60!%5B%24%7Bgiph.slug%7D%5D(%24%7Bgiph.images.downsized_medium.url%7D)%60%3B%0A%0Atarget.dispatchEvent(new%20Event(%22change%22))%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "670px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "33.18385650224215%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'133\\'%20viewBox=\\'0%200%20400%20133\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M19%2030v38l1%2037h361V30l-181-1-181%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/71305a61cd26a7de77bce0432dba952f/ca0a1/techletter.app-screenshot-1563209612899.webp 223w", "/static/71305a61cd26a7de77bce0432dba952f/75680/techletter.app-screenshot-1563209612899.webp 445w", "/static/71305a61cd26a7de77bce0432dba952f/6cceb/techletter.app-screenshot-1563209612899.webp 670w"],
                "sizes": "(max-width: 670px) 100vw, 670px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/71305a61cd26a7de77bce0432dba952f/e92b6/techletter.app-screenshot-1563209612899.png 223w", "/static/71305a61cd26a7de77bce0432dba952f/e66bf/techletter.app-screenshot-1563209612899.png 445w", "/static/71305a61cd26a7de77bce0432dba952f/d67fd/techletter.app-screenshot-1563209612899.png 670w"],
                "sizes": "(max-width: 670px) 100vw, 670px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/71305a61cd26a7de77bce0432dba952f/d67fd/techletter.app-screenshot-1563209612899.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><img parentName="p" {...{
        "src": "/d618a162dac385f4439d7a9d6c341fb0/ueM8veJ.gif",
        "alt": null
      }}></img></p>
    <p>{`Nope.`}</p>
    <p>{`That's strange. How could a change event `}<em parentName="p">{`not`}</em>{` make it work? Most frameworks use the `}<inlineCode parentName="p">{`onChange`}</inlineCode>{` event ...`}</p>
    <p>{`But then you look at the list of events GitHub's textarea is listening for and wow that's a lot.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "868px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/54a9592d69db42b7c09be044d71460d1/748b0/svidZbN.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "54.26008968609865%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'217\\'%20viewBox=\\'0%200%20400%20217\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M22%206c-1%202-1%206%201%207v-3c0-2%200-2%201%200l2%204c-1%203%200%202%202-2s2-4%202-2c0%203%202%204%202%202h1c1%201%2010%201%2010-1l-1-1V9c2-1%202-1-4-2-3%200-4%200-3%201s1%201-1%201l-2-2-1-2-3%204-1%201-1-1-1-2-2-1h-1m142%203c0%204%200%204%204%204l3-1h2c1%202%204%202%204-1l-1-1V9c2-1%202%200%202%201%200%202%200%203%204%203%203%200%204-1%204-2h1c0%203%202%202%202%200l1-2c1-1%201%200%201%201%200%203%200%203%205%203%204%200%205-1%205-2l1-3c1-1%201-1-1-1l-2%201h-1l-2-1-2%201h-2l-3-1-2%201h-1l-3-1h-8l-3%202c0%201-1%201-1-1-1-3-1-3-1%200%200%206-4%205-5%200l-1-3v4m63%200c0%204%200%204%202%204l4-2c1-1%201-1%202%201%203%203%207%201%207-3s-4-6-7-3c-1%202-1%202-2%201l-4-2c-2%200-2%200-2%204m138-2l-3%201h-7c-3-3-5-1-5%203%200%203%200%204%201%203l2-1%202-1h1c2%202%205%201%205-1h1c0%203%202%202%202%200%200-3%202-3%202-1%201%204%205%204%205%200l-1-3h-5M179%2030c-2%201-1%209%201%209%205%203%209%200%209-6%200-3-1-4-5-4l-5%201m-94%201l-2%201-4%201h-1l-2-1-2%201-4%204-1-2c0-2%200-2%202-2h1c0-2-4-1-4%201-1%203%200%204%205%204%204%200%205-1%205-2l2-1v1c-2%200%200%202%202%202s3-3%201-3v-1c2-1%202%200%202%202l1%202c1%200%202-1%201-3%200-2%200-2%201%200%200%202%201%203%203%203%204%200%204-5%200-6l-4-1h-2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/54a9592d69db42b7c09be044d71460d1/ca0a1/svidZbN.webp 223w", "/static/54a9592d69db42b7c09be044d71460d1/75680/svidZbN.webp 445w", "/static/54a9592d69db42b7c09be044d71460d1/1ae05/svidZbN.webp 868w"],
              "sizes": "(max-width: 868px) 100vw, 868px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/54a9592d69db42b7c09be044d71460d1/e92b6/svidZbN.png 223w", "/static/54a9592d69db42b7c09be044d71460d1/e66bf/svidZbN.png 445w", "/static/54a9592d69db42b7c09be044d71460d1/748b0/svidZbN.png 868w"],
              "sizes": "(max-width: 868px) 100vw, 868px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/54a9592d69db42b7c09be044d71460d1/748b0/svidZbN.png",
              "alt": "svidZbN",
              "title": "svidZbN",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Maybe we need to replay the full keyboard interaction to make this work? Something crazy like `}<a parentName="p" {...{
        "href": "https://stackoverflow.com/a/23964375"
      }}>{`this StackOverflow comment`}</a>{` lists?`}</p>
    <p>{`Focus, keydown, beforeinput, keypress, input, change, keyup ... essentially replaying the whole sequence of events as if this were a real user interacting with the website.`}</p>
    <p>{`It didn't work.`}</p>
    <p>{`Not only didn't it work, the content didn't even show up. You still have to call `}<inlineCode parentName="p">{`textarea.value +=`}</inlineCode>{`.`}</p>
    <p>{`We even tried faking the `}<inlineCode parentName="p">{`input`}</inlineCode>{` event to make it look like a copy paste. Didn't work. Not even gonna show you the code.`}</p>
    <h3 {...{
      "id": "what-about-faking-the-textarea-itself"
    }}>{`What about faking the textarea itself?`}</h3>
    <p>{`The craziest idea was replacing the whole textarea with a textarea of our own. If you could unrender that one and make it listen to all the same DOM events as the original, that should be seamless, right?`}</p>
    <p>{`Unfortunately you can't get a list of event listeners for a DOM node.`}</p>
    <p>{`Yes Chrome lists them in dev tools. You can even use `}<inlineCode parentName="p">{`getEventListeners`}</inlineCode>{` in Chrome console.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "868px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/54a9592d69db42b7c09be044d71460d1/748b0/svidZbN.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "54.26008968609865%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'217\\'%20viewBox=\\'0%200%20400%20217\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M22%206c-1%202-1%206%201%207v-3c0-2%200-2%201%200l2%204c-1%203%200%202%202-2s2-4%202-2c0%203%202%204%202%202h1c1%201%2010%201%2010-1l-1-1V9c2-1%202-1-4-2-3%200-4%200-3%201s1%201-1%201l-2-2-1-2-3%204-1%201-1-1-1-2-2-1h-1m142%203c0%204%200%204%204%204l3-1h2c1%202%204%202%204-1l-1-1V9c2-1%202%200%202%201%200%202%200%203%204%203%203%200%204-1%204-2h1c0%203%202%202%202%200l1-2c1-1%201%200%201%201%200%203%200%203%205%203%204%200%205-1%205-2l1-3c1-1%201-1-1-1l-2%201h-1l-2-1-2%201h-2l-3-1-2%201h-1l-3-1h-8l-3%202c0%201-1%201-1-1-1-3-1-3-1%200%200%206-4%205-5%200l-1-3v4m63%200c0%204%200%204%202%204l4-2c1-1%201-1%202%201%203%203%207%201%207-3s-4-6-7-3c-1%202-1%202-2%201l-4-2c-2%200-2%200-2%204m138-2l-3%201h-7c-3-3-5-1-5%203%200%203%200%204%201%203l2-1%202-1h1c2%202%205%201%205-1h1c0%203%202%202%202%200%200-3%202-3%202-1%201%204%205%204%205%200l-1-3h-5M179%2030c-2%201-1%209%201%209%205%203%209%200%209-6%200-3-1-4-5-4l-5%201m-94%201l-2%201-4%201h-1l-2-1-2%201-4%204-1-2c0-2%200-2%202-2h1c0-2-4-1-4%201-1%203%200%204%205%204%204%200%205-1%205-2l2-1v1c-2%200%200%202%202%202s3-3%201-3v-1c2-1%202%200%202%202l1%202c1%200%202-1%201-3%200-2%200-2%201%200%200%202%201%203%203%203%204%200%204-5%200-6l-4-1h-2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/54a9592d69db42b7c09be044d71460d1/ca0a1/svidZbN.webp 223w", "/static/54a9592d69db42b7c09be044d71460d1/75680/svidZbN.webp 445w", "/static/54a9592d69db42b7c09be044d71460d1/1ae05/svidZbN.webp 868w"],
              "sizes": "(max-width: 868px) 100vw, 868px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/54a9592d69db42b7c09be044d71460d1/e92b6/svidZbN.png 223w", "/static/54a9592d69db42b7c09be044d71460d1/e66bf/svidZbN.png 445w", "/static/54a9592d69db42b7c09be044d71460d1/748b0/svidZbN.png 868w"],
              "sizes": "(max-width: 868px) 100vw, 868px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/54a9592d69db42b7c09be044d71460d1/748b0/svidZbN.png",
              "alt": "svidZbN",
              "title": "svidZbN",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`There's no way to get them in real code.`}</p>
    <p><img parentName="p" {...{
        "src": "/5c33febc979117f9b6273bef20f58f04/media-26u4hUmb6nL1kZ6Le-giphy.gif",
        "alt": "foiled_again giphy"
      }}></img></p>
    <h2 {...{
      "id": "wisdom-of-the-crowds-to-the-rescue"
    }}>{`Wisdom of the crowds to the rescue`}</h2>
    <p>{`Out of options, out of ideas, I asked the internet for help.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1150534623954210817"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "99.10313901345292%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'396\\'%20viewBox=\\'0%200%20400%20396\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M32%2021c-13%207-9%2026%206%2028%207%200%2015-5%209-6-5-1-3-6%202-6l2-1%202-1%201-2-4-9-3-2c-3-3-10-4-15-1m176%20166v6h4c5%200%207-2%207-6s-2-6-7-6h-4v6m15-4c-2%201-2%206-1%208%202%203%208%202%2010-1%203-6-5-12-9-7M26%20203c-3%205%200%2010%205%2010%203%200%205-2%205-5%200-5-2-7-5-7s-4%201-5%202m73%2082c-2%201-2%201-1%203l1%207-1%204h13l-1-4%201-7c2-1%202-1%200-3s-4-3-4-1l1%201%201%201-1%201-2%201%202%201%201%204v4h-8v-4c0-3%200-4%202-4l1-1-2-1c-2%200-2%200%200-2s0-3-3%200m-9%2052c-4%205-1%2013%205%2013s10-7%207-11c-4-4-8-5-12-2m18%200c-6%207%203%2017%2010%2011%203-3%203-7%201-10-4-4-7-4-11-1m-36%200c-1%202%200%209%203%2011%202%201%203%202%205%201l1-2v-2l-1-1-2-1h2c3%200%203-5%201-6h-9\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d212d1ea10ed92d30607527fec87db69/ca0a1/techletter.app-screenshot-1563209611797.webp 223w", "/static/d212d1ea10ed92d30607527fec87db69/75680/techletter.app-screenshot-1563209611797.webp 445w", "/static/d212d1ea10ed92d30607527fec87db69/0ba47/techletter.app-screenshot-1563209611797.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d212d1ea10ed92d30607527fec87db69/e92b6/techletter.app-screenshot-1563209611797.png 223w", "/static/d212d1ea10ed92d30607527fec87db69/e66bf/techletter.app-screenshot-1563209611797.png 445w", "/static/d212d1ea10ed92d30607527fec87db69/6af66/techletter.app-screenshot-1563209611797.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/d212d1ea10ed92d30607527fec87db69/6af66/techletter.app-screenshot-1563209611797.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`And the internet delivered! Thanks `}<a parentName="p" {...{
        "href": "https://twitter.com/_tarekdj"
      }}>{`@`}{`_`}{`tarekdj`}</a></p>
    <p>{`Firing the `}<inlineCode parentName="p">{`change`}</inlineCode>{` event was the right idea. I was just doing it wrong.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/_tarekdj/status/1150540911866187779"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "110.31390134529148%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'441\\'%20viewBox=\\'0%200%20400%20441\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M148%209c-2%201-1%208%200%209l7%201h6V8h-6l-7%201M27%20114l-2%202-1%2085v86h350v-85c0-85%200-86-2-88-3-3-341-3-345%200m31%20116c-14%203-19%2019-10%2030%203%203%208%206%209%205%202-1%201-3-1-3s-4-1-5-3c-2-3-2-4%202-1%202%202%205%202%205%200l-3-3c-3-1-5-5-4-9l1-6c0-2%201-3%202-2h16c2%200%202%200%204%205%201%206%200%2012-4%2013-3%200-3%201-3%205%200%205%201%206%205%204%208-5%2012-17%207-26-1-3-8-8-11-8-5-2-7-2-10-1m40%205c-5%203-8%209-7%2017%202%207%208%2011%2016%209l4-1v-14h-4c-5%200-5%200-5%203l2%202c1%200%202%201%202%203%200%203-5%203-7%200-5-6-1-14%206-14%204%200%207-3%205-5H98m107%201c-5%203-6%2014-2%2021%201%203%204%204%2011%204h5v-14h-4l-4%201%203%201c2%200%202%200%202%205v5h-4c-6%200-8-2-9-10%200-9%204-14%2011-12h4c0-2-4-3-8-3l-5%202m-69%2012v13h3c2%200%202%200%202-5v-6h8v6c0%205%200%205%203%205h2v-26h-2c-3%200-3%200-3%205%200%204-1%205-4%205h-4v-5c0-5%200-5-2-5h-3v13m40-12l-1%2013v12h11c4%200%206-3%206-9%200-7-2-9-7-9l-4%201v-5c0-4%200-4-2-4l-3%201m-52%205l-1%203-2%202%201%202c2%200%202%202%202%206%201%206%203%209%207%207%203%200%202-4%200-4-2-1-2-2-2-4%200-3%200-4%202-5%201%200%202-1%202-3l-2-2-2-2c0-2%200-3-2-3-3%200-3%200-3%203m33%2010c0%209%202%2012%208%2010h6c2%200%202%200%202-9%200-8-1-8-3-8s-3%200-3%206c0%207%200%207-2%207s-3-1-3-7-1-7-3-7-2%200-2%208\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f1cd5026aee51534d16b1f027b73fd64/ca0a1/techletter.app-screenshot-1563209611708.webp 223w", "/static/f1cd5026aee51534d16b1f027b73fd64/75680/techletter.app-screenshot-1563209611708.webp 445w", "/static/f1cd5026aee51534d16b1f027b73fd64/0ba47/techletter.app-screenshot-1563209611708.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f1cd5026aee51534d16b1f027b73fd64/e92b6/techletter.app-screenshot-1563209611708.png 223w", "/static/f1cd5026aee51534d16b1f027b73fd64/e66bf/techletter.app-screenshot-1563209611708.png 445w", "/static/f1cd5026aee51534d16b1f027b73fd64/6af66/techletter.app-screenshot-1563209611708.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/f1cd5026aee51534d16b1f027b73fd64/6af66/techletter.app-screenshot-1563209611708.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20Make%20this%20damn%20textarea%20works!%0Alet%20evt%20%3D%20document.createEvent(%22Events%22)%3B%0Aevt.initEvent(%22change%22%2C%20true%2C%20true)%3B%0Atarget.dispatchEvent(evt)%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "430px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.05381165919282%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'224\\'%20viewBox=\\'0%200%20400%20224\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%2046l-1%2067%201%2065%202%202%20167%201%20167-1%203-2v-65l-1-67c-2-2-336-2-338%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/719f15aad6aae6e244b87137e96b8ca0/ca0a1/techletter.app-screenshot-1563209613024.webp 223w", "/static/719f15aad6aae6e244b87137e96b8ca0/866c5/techletter.app-screenshot-1563209613024.webp 430w"],
                "sizes": "(max-width: 430px) 100vw, 430px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/719f15aad6aae6e244b87137e96b8ca0/e92b6/techletter.app-screenshot-1563209613024.png 223w", "/static/719f15aad6aae6e244b87137e96b8ca0/05ed2/techletter.app-screenshot-1563209613024.png 430w"],
                "sizes": "(max-width: 430px) 100vw, 430px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/719f15aad6aae6e244b87137e96b8ca0/05ed2/techletter.app-screenshot-1563209613024.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><img parentName="p" {...{
        "src": "/f926a0b2933da5abff3ea85199f2ec5a/ackL13M.gif",
        "alt": null
      }}></img></p>
    <p>{`Yay it works!`}</p>
    <p>{`Sure, the framework error is still there but we can fix that with a submit button instead of pressing Enter. I've tried, it worked.`}</p>
    <p>{`As long as it doesn't break functionality I'm okay with firing an error.`}</p>
    <p>{`What's more curious is why `}<a parentName="p" {...{
        "href": "https://twitter.com/_tarekdj"
      }}>{`@`}{`_`}{`tarekdj`}</a>{`'s change event works and mine doesn't.`}</p>
    <h2 {...{
      "id": "a-change-event-is-not-a-change-event"
    }}>{`A change event is not a change event`}</h2>
    <p>{`Let's see, we've got two change events. One works, one doesn't`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20this%20doesn't%20work%0A%0Atarget.dispatchEvent(new%20Event(%22change%22))%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "438px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "51.12107623318386%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'204\\'%20viewBox=\\'0%200%20400%20204\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%2046c-3%203-3%20111%200%20113%202%203%20336%203%20338%200%203-3%203-111%200-113-3-3-336-3-338%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0d81ceb4bc98f88343ce50bf85c2b005/ca0a1/techletter.app-screenshot-1563209612502.webp 223w", "/static/0d81ceb4bc98f88343ce50bf85c2b005/4a74f/techletter.app-screenshot-1563209612502.webp 438w"],
                "sizes": "(max-width: 438px) 100vw, 438px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0d81ceb4bc98f88343ce50bf85c2b005/e92b6/techletter.app-screenshot-1563209612502.png 223w", "/static/0d81ceb4bc98f88343ce50bf85c2b005/50e4b/techletter.app-screenshot-1563209612502.png 438w"],
                "sizes": "(max-width: 438px) 100vw, 438px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/0d81ceb4bc98f88343ce50bf85c2b005/50e4b/techletter.app-screenshot-1563209612502.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`We're creating a new Event as per `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Event"
      }}>{`MDN docs`}</a>{`. It's the most basic of event objects that all the others build off of.`}</p>
    <blockquote>
      <p parentName="blockquote">{`The Event interface represents an event which takes place in the DOM.`}</p>
    </blockquote>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Event/Event"
      }}>{`Event Constructor`}</a>{` creates an event object of a certain type. `}<inlineCode parentName="p">{`dispatchEvent`}</inlineCode>{` fires it.`}</p>
    <p>{`Second argument is an `}<inlineCode parentName="p">{`EventInit`}</inlineCode>{` dictionary with options. By default events are non-bubbling.`}</p>
    <p>{`That feels important 🤔`}</p>
    <p>{`Event bubbling is how events propagate up the hierarchy of DOM elements by the way. That's how a form knows to submit when you press Enter inside an input field 5 levels down.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20this%20works%0A%0Alet%20evt%20%3D%20document.createEvent(%22Events%22)%3B%0Aevt.initEvent(%22change%22%2C%20true%2C%20true)%3B%0Atarget.dispatchEvent(evt)%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "430px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "60.0896860986547%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'241\\'%20viewBox=\\'0%200%20400%20241\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%2046c-2%202-1%20148%201%20150s334%202%20336%200%203-148%201-150-336-2-338%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c4ce66d1e9442efbc0619d23f9e39717/ca0a1/techletter.app-screenshot-1563209612754.webp 223w", "/static/c4ce66d1e9442efbc0619d23f9e39717/866c5/techletter.app-screenshot-1563209612754.webp 430w"],
                "sizes": "(max-width: 430px) 100vw, 430px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c4ce66d1e9442efbc0619d23f9e39717/e92b6/techletter.app-screenshot-1563209612754.png 223w", "/static/c4ce66d1e9442efbc0619d23f9e39717/05ed2/techletter.app-screenshot-1563209612754.png 430w"],
                "sizes": "(max-width: 430px) 100vw, 430px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/c4ce66d1e9442efbc0619d23f9e39717/05ed2/techletter.app-screenshot-1563209612754.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`The working version `}<em parentName="p">{`also`}</em>{` creates an event and dispatches it. Except it's using a more old school approach.`}</p>
    <p>{`Calls `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Document/createEvent"
      }}>{`createEvent`}</a>{` which has a shiny red banner saying we should be using event constructors instead. But it still creates an uninitialized event.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Creates an event of the type specified. The returned object should be first initialized and can then be passed to EventTarget.dispatchEvent.`}</p>
    </blockquote>
    <p>{`The `}<inlineCode parentName="p">{`initEvent`}</inlineCode>{` call initializes it.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/c78211dd4abd89e672a3c0e1d3174fef/10d53/7vuC9hE.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "27.802690582959645%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'110\\'%20viewBox=\\'0%200%20400%20110\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M5%2055l1%2050a1196%201196%200%2000-1-50m17-37c0%203%203%204%206%202h1l2%201c1-1%202%200%202%201l2%201%201-1c-1-1%200-1%203-1l2-1v-2l1%201c1%201%204%202%2014%202h13v-4c0-2%200-3-2-3l-1%201c1%201-2%202-3%201l-2%201h-2c-1-3-3-2-3%201%200%202%200%202-1%200%200-2-1-2-13-2l-15-1c-2-2-5-1-5%203m160%2012l1%201%201%203%201%202%201-2%201-3%201%203c0%203%202%203%202%200%201-2%201-2%201%200%200%201%201%202%203%202%201%200%202-1%201-2v-1c1-1%201%200%201%201l1%201h1l4%201h4c1%201%201%200%201-1l1-3v3l1%201%201-2%201-2v2c0%202%202%203%202%200%200-2-4-6-5-4l-2%201-3%202c-1%202-1%202-1%200v-2l-1%202-1%202-1-4-1%201h-1c0-2-3-1-4%201h-1c0-3-10-6-10-3m-55%202l-1%201c-1-1-1%200-1%201h1l1%201%202%201c2%200%203-1%202-2v-1c1-1%201%200%201%201l1%201h1c0%202%206%201%206-1%201-2%201-2%201%200l1%202%201-2%201-2v2l2%202%202-2%201-2v2l1%202%201-2c1-2%201-2%201%200l2%202%202-1%201-1h1c0-1%200-2-1-1l-1-1v-1l-2%202h-1c0-1-1-2-3-2-3%200-4%200-3%202l-1%201-1-1c0-1-1-2-3-2-3%200-4%200-3%202h-1c-1-2-12-2-11-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/c78211dd4abd89e672a3c0e1d3174fef/ca0a1/7vuC9hE.webp 223w", "/static/c78211dd4abd89e672a3c0e1d3174fef/75680/7vuC9hE.webp 445w", "/static/c78211dd4abd89e672a3c0e1d3174fef/8d1ba/7vuC9hE.webp 890w", "/static/c78211dd4abd89e672a3c0e1d3174fef/3838e/7vuC9hE.webp 1335w", "/static/c78211dd4abd89e672a3c0e1d3174fef/0f980/7vuC9hE.webp 1724w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/c78211dd4abd89e672a3c0e1d3174fef/e92b6/7vuC9hE.png 223w", "/static/c78211dd4abd89e672a3c0e1d3174fef/e66bf/7vuC9hE.png 445w", "/static/c78211dd4abd89e672a3c0e1d3174fef/4ef49/7vuC9hE.png 890w", "/static/c78211dd4abd89e672a3c0e1d3174fef/4e814/7vuC9hE.png 1335w", "/static/c78211dd4abd89e672a3c0e1d3174fef/10d53/7vuC9hE.png 1724w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/c78211dd4abd89e672a3c0e1d3174fef/4ef49/7vuC9hE.png",
              "alt": "7vuC9hE",
              "title": "7vuC9hE",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`That's not a good sign 😅`}</p>
    <p>{`What do those booleans we're passing in do? Here's the function signature`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=event.initEvent(type%2C%20bubbles%2C%20cancelable)%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "446px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "41.70403587443946%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'168\\'%20viewBox=\\'0%200%20400%20168\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%2044c-3%202-3%2079%200%2081h338c2-1%202-3%202-40%200-38%200-40-2-41H31\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/918d9badebeda6bf51f5352ced4aa36d/ca0a1/techletter.app-screenshot-1563209612998.webp 223w", "/static/918d9badebeda6bf51f5352ced4aa36d/75680/techletter.app-screenshot-1563209612998.webp 445w", "/static/918d9badebeda6bf51f5352ced4aa36d/5021b/techletter.app-screenshot-1563209612998.webp 446w"],
                "sizes": "(max-width: 446px) 100vw, 446px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/918d9badebeda6bf51f5352ced4aa36d/e92b6/techletter.app-screenshot-1563209612998.png 223w", "/static/918d9badebeda6bf51f5352ced4aa36d/e66bf/techletter.app-screenshot-1563209612998.png 445w", "/static/918d9badebeda6bf51f5352ced4aa36d/6244b/techletter.app-screenshot-1563209612998.png 446w"],
                "sizes": "(max-width: 446px) 100vw, 446px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/918d9badebeda6bf51f5352ced4aa36d/6244b/techletter.app-screenshot-1563209612998.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`🤔`}</p>
    <p>{`So it `}<em parentName="p">{`was`}</em>{` all about bubbling! Let's try`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=target.dispatchEvent(%0A%20%20%20%20new%20Event(%22change%22%2C%20%7B%0A%20%20%20%20%20%20%20%20bubbles%3A%20true%0A%20%20%20%20%7D)%0A)%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "302px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "85.65022421524664%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'343\\'%20viewBox=\\'0%200%20400%20343\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M45%2066l-2%203v104l1%20105c1%202%204%203%207%203h299c3%200%206-1%207-3l1-106V68l-2-2-3-2H47l-2%202m47%2021c-4%205-1%2013%205%2013%203%200%208-5%208-8%200-7-9-10-13-5m29-2c-5%202-6%207-3%2011%205%207%2015%201%2012-7%200-2-5-5-6-5l-3%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ffa6df5fc48783033a6e833994bcb775/ca0a1/techletter.app-screenshot-1563209613009.webp 223w", "/static/ffa6df5fc48783033a6e833994bcb775/7cc02/techletter.app-screenshot-1563209613009.webp 302w"],
                "sizes": "(max-width: 302px) 100vw, 302px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ffa6df5fc48783033a6e833994bcb775/e92b6/techletter.app-screenshot-1563209613009.png 223w", "/static/ffa6df5fc48783033a6e833994bcb775/5f1d2/techletter.app-screenshot-1563209613009.png 302w"],
                "sizes": "(max-width: 302px) 100vw, 302px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/ffa6df5fc48783033a6e833994bcb775/5f1d2/techletter.app-screenshot-1563209613009.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`It works! 😱`}</p>
    <p><img parentName="p" {...{
        "src": "/c68dafc1f0db62cea8f70492a22563ef/IfyZl1Y.gif",
        "alt": null
      }}></img></p>
    <p>{`Well that was fun. Thanks for reading.`}</p>
    <p>{`Happy Monday ✌️,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      